var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1944 2.7424C12.0187 2.2736 11.4449 2.02432 10.9935 2.24C10.3851 2.53072 9.59114 2.84568 9.0069 2.84568C8.39457 2.84568 7.55184 2.4997 6.93384 2.19827C6.50975 1.99143 5.97314 2.19656 5.78385 2.62914C5.51531 3.24285 5.08281 4.05881 4.48636 4.65592C3.94446 5.19843 3.26722 5.56029 2.72503 5.78662C2.26937 5.97683 2.03054 6.54527 2.24406 6.99089C2.53715 7.60259 2.85897 8.40894 2.85897 9.00049C2.85897 9.62213 2.50359 10.481 2.19961 11.1018C1.99597 11.5178 2.18788 12.0447 2.6047 12.2458C3.16422 12.5159 3.90356 12.9426 4.48636 13.5261C5.05831 14.0987 5.4795 14.8222 5.74993 15.3784C5.95725 15.8048 6.51364 16.0073 6.93959 15.7998C7.55701 15.4991 8.39635 15.1553 9.0069 15.1553C9.59779 15.1553 10.4032 15.4775 11.0142 15.7709C11.4594 15.9847 12.0272 15.7456 12.2172 15.2894C12.4432 14.7466 12.8047 14.0686 13.3466 13.5261C13.9431 12.929 14.7581 12.496 15.3711 12.2271C15.8032 12.0376 16.0081 11.5004 15.8015 11.0759C15.5004 10.4572 15.1548 9.61351 15.1548 9.00049C15.1548 8.4156 15.4694 7.62073 15.7598 7.01164C15.9753 6.55974 15.7263 5.98534 15.258 5.80937C14.6605 5.58484 13.9071 5.21699 13.3466 4.65592C12.7862 4.09485 12.4187 3.34056 12.1944 2.7424Z",
    fill: "#74747B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3654 11.4574L6.72712 6.81915M6.72712 11.4574L11.3654 6.81915",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/notVerified.a8abd8dfe9697ec6a6830e96b31429d2.svg";
export { ForwardRef as ReactComponent };